export const LOAD_UBISOFT_OVERLAY_DONE = 'LOAD_UBISOFT_OVERLAY_DONE';
export const LOAD_UBISOFT_OVERLAY_ERROR = 'LOAD_UBISOFT_OVERLAY_ERROR';

export const INITIALIZE_UBISOFT_OVERLAY_DONE = 'INITIALIZE_UBISOFT_OVERLAY_DONE';
